import ActionTypes from '../constants/ActionTypes';

const initialState = {
  dailyReport: {},
  monthlyReport: {},
  yearlyReport: {},
  updatedAt: new Date(),
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.DAILY_REPORTS_FETCH_SUCCEEDED:
      return {
        ...state,
        dailyReport: payload.reports,
      };
    case ActionTypes.MONTHLY_REPORTS_FETCH_SUCCEEDED:
      return {
        ...state,
        monthlyReport: payload.reports,
      };
    case ActionTypes.YEARLY_REPORTS_FETCH_SUCCEEDED:
      return {
        ...state,
        yearlyReport: payload.reports,
      };
    case ActionTypes.DEVICE_ITEMS_UPDATE_RECEIVED:
      return {
        ...state,
        updatedAt: new Date(payload.items.createdAt),
      };
    default:
      return state;
  }
};
